import React, { useEffect, createElement } from 'react';
import { Check, MessageCircle } from 'lucide-react';
export function ThankYouPage() {
  useEffect(() => {
    // Meta Pixel Code - Simplified implementation
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '754551913878347');
      fbq('track', 'Purchase');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      // Cleanup if needed
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50 flex items-center justify-center p-6" data-id="element-7">
      <div className="max-w-2xl w-full" data-id="element-8">
        {/* Success Icon */}
        <div className="flex justify-center mb-8" data-id="element-9">
          <div className="w-20 h-20 bg-emerald-500 rounded-full flex items-center justify-center shadow-lg shadow-emerald-500/30" data-id="element-10">
            <Check className="w-12 h-12 text-white" strokeWidth={3} data-id="element-11" />
          </div>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center" data-id="element-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-13">
            ¡Gracias por tu compra!
          </h1>

          <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-14">
            Tu acceso al área de miembros será enviado a tu correo electrónico
            en las próximas horas.
          </p>

          <div className="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-6 mb-8" data-id="element-15">
            <p className="text-gray-700 text-lg" data-id="element-16">
              Revisa tu bandeja de entrada y la carpeta de spam para asegurarte
              de recibir tu acceso.
            </p>
          </div>

          {/* WhatsApp Contact Section */}
          <div className="border-t border-gray-200 pt-8" data-id="element-17">
            <p className="text-gray-600 mb-6 text-lg" data-id="element-18">
              ¿Tienes alguna pregunta? Contáctame por WhatsApp
            </p>

            <a href="https://wa.link/truemarketer-support" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold px-8 py-4 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 text-lg" data-id="element-19">
              <MessageCircle className="w-6 h-6" fill="currentColor" data-id="element-20" />
              Chatear por WhatsApp
            </a>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center text-gray-500 mt-8 text-sm" data-id="element-21">
          Estamos aquí para ayudarte en cada paso del camino
        </p>
      </div>
    </div>;
}